export const COOKIE_NAME = 'dws_cookies_consent';

export const ANALYTICS_CONSENT_COOKIE_NAME = 'dws_analytics_cookies_consent';
